import { useLingui } from "@lingui/react/macro";
import CalendarIcon from "@medoma/components/icons/CalendarIcon";
import PersonInformationIcon from "@medoma/components/icons/PersonInformationIcon";
import DevicesIcon from "@medoma/components/icons/DevicesIcon";
import ClipboardPlusIcon from "@medoma/components/icons/ClipboardPlusIcon";
import type { IPatientId } from "@medoma/models/patients";
import { ActionCardLink } from "@/components/ActionCard/ActionCard";
import styles from "./PatientSectionLinks.module.scss";

export const PatientSectionLinks = ({
  patientId,
}: {
  patientId: IPatientId;
}) => {
  const { t } = useLingui();
  const patientPath = `/patients/${patientId}`;

  return (
    <ul className={styles.sectionLinks}>
      <li>
        <ActionCardLink
          to={`${patientPath}/activities`}
          title={t`Aktiviteter`}
          icon={<CalendarIcon />}
        />
      </li>
      <li>
        <ActionCardLink
          to={`${patientPath}/information`}
          title={t`Information`}
          icon={<PersonInformationIcon />}
        />
      </li>
      <li>
        <ActionCardLink
          to={`${patientPath}/care-episode`}
          title={t`Vårdperiod`}
          icon={<ClipboardPlusIcon />}
        />
      </li>
      <li>
        <ActionCardLink
          to={`${patientPath}/authentication`}
          title={t`Inloggning`}
          icon={<DevicesIcon />}
        />
      </li>
    </ul>
  );
};
